import * as PDFIcons from '../Icons/PDF';
import * as ThirdPartyIcons from '../Icons/ThirdParty';
import * as WOPIIcons from '../Icons/WOPI';
import * as EditorIcons from '../Icons/Editor';

const icons = {
  ...PDFIcons,
  ...ThirdPartyIcons,
  ...WOPIIcons,
  ...EditorIcons,
};

type IconName = keyof typeof icons;

type CustomIconProps = {
  name: IconName;
  color?: string;
  selected?: boolean;
  size: 16 | 24 | 32;
};

const CustomIcon = ({ name, color, selected, size }: CustomIconProps) => {
  const IconComponent = icons[name];
  if (!IconComponent) return null;
  return <IconComponent color={color} selected={selected} size={size} />;
};

export default CustomIcon;
